import {Component, OnInit, OnDestroy} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {ApiDirectoryItemService} from '../../services/api-directory.service';
import {DirectoryService} from '../../services/directory.service';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/pairwise';
import {AccountStatementDetails} from '../../types/interface.types';
import {CondomanagerService} from '../../services/condomanager.service';
import {filter, flatMap, tap} from 'rxjs/operators';

@Component({
    selector: 'directory-item',
    templateUrl: 'directory-item.template.html',
    providers: [ApiDirectoryItemService]
})
export class DirectoryItemComponent implements OnInit, OnDestroy {

    public suiteId = 0;
    public suiteData: any;
    private sub: any;
    public spinnerShow: boolean;

    public residentsList: Array<any> = [];
    public parkingList: Array<any> = [];
    public lockersList: Array<any> = [];
    public vehicleList: Array<any> = [];
    public petsList: Array<any> = [];
    public bikeRacksList: Array<any> = [];

    // account statement
    isShowAccountBalance = false;
    accountBalance: number = null;
    accountStatements: AccountStatementDetails[] = null;

    constructor(
        private route: ActivatedRoute,
        public router: Router,
        private api: ApiDirectoryItemService,
        public directoryService: DirectoryService,
        public condomanagerService: CondomanagerService
    ) {
    }

    ngOnInit() {
        this.sub = this.route.params.subscribe((params: Params) => {
            this.suiteId = parseInt(params['id']);
            this.api.getSuite(this.suiteId)
                .pipe(
                    tap((res) => {
                        this.suiteData = res;
                    }),
                    flatMap(
                        () => this.getAccountStatement(this.suiteData.building.id, this.suiteData.suiteNumber)
                    ),
                )
                .subscribe();
        });
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    /**
     * Retrieves account statement details
     */
    private getAccountStatement(buildingId: number, suiteNumber: string) {
        // force reset
        this.accountBalance = null;
        this.accountStatements = null;
        this.isShowAccountBalance = false;
        const params = {'per-page': 9999};

        return this.condomanagerService.getStatementsList(buildingId, suiteNumber, params)
            .pipe(
                filter(result => !result.error),
                tap((result) => {
                    this.accountStatements = result.entities;
                    this.accountBalance = result.balance;
                    this.isShowAccountBalance = result.finished;
                })
            );
    }

    /**
     * Shows up account statement details
     * in modal window
     */
    public showAccountBalanceModal() {
        this.condomanagerService.accountStatementModalDetails = this.accountStatements;
    }

    userIsSuperAdmin() {
        const userType = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).userType : '';
        return userType == 'super_admin';
    }
}




// WEBPACK FOOTER //
// /app/src/app/views/directory-item/directory-item.component.ts